<template>
    <t-modal
        v-model="openModal"
        :classes="classes"
        @input="$emit('update:showModal', openModal);"
    >
        <div class="modal-body">
            <h1 class="text-center">
                {{ __('Elfogyott a méret?') }}
            </h1>

            <div>
                <portal-target
                    v-if="portalAvailable"
                    name="product-show-out-of-stock-notification-modal"
                />
            </div>

            <div v-if="successMessage"
                 class="alert alert-success"
            >
                {{ __(successMessage) }}
            </div>

            <div v-else>
                <div class="form-group mt-10">
                    <label for="notification_email">
                        {{ __('Email cím') }}*
                    </label>

                    <input v-model="email"
                           class="form-control border w-full p-2"
                           type="email"
                           id="notification_email"
                           required
                    >
                </div>

                <div class="form-group mt-10">
                    <label for="notification_phone">
                        {{ __('Telefonszám') }}*
                    </label>

                    <input v-model="phone"
                           class="form-control border w-full p-2"
                           type="tel"
                           id="notification_phone"
                           required
                    >
                </div>

                <div class="form-group mt-10">
                    <label for="notification_size">
                        {{ __('Méret') }}*
                    </label>

                    <select v-model="size"
                            class="form-control border w-full p-2"
                            id="notification_size"
                    >
                        <option v-for="size in product.sizes.filter((size) => size.quantity <= 0)"
                                :value="size.name"
                        >
                            {{ size.name }}
                        </option>
                    </select>
                </div>

                <div class="form-group mt-10">
                    <label for="notification_message">
                        {{ __('Üzenet') }}
                    </label>

                    <textarea v-model="message"
                              class="form-control border w-full p-2"
                              id="notification_message"
                              rows="2"
                              required
                    ></textarea>
                </div>

                <div class="mt-10 text-sm">
                    <span>* {{ __('Kötelezően kitöltendő mezők.') }}</span>
                </div>

                <div v-if="errorMessage"
                     class="alert alert-danger mt-5"
                >
                    {{ __(errorMessage) }}
                </div>

                <div class="form-group mt-10">
                    <button class="btn btn-primary"
                            :disabled="isSending"
                            @click="send"
                    >
                        {{ __('Küldés') }}
                    </button>
                </div>
            </div>
        </div>
    </t-modal>
</template>

<script>
export default {
    name: 'OutOfStockNotificationModal',

    props: {
        showModal: {
            type: Boolean,
        },

        product: {
            type: Object,
            required: true,
        },

        userEmail: {
            type: String,
            default: () => null,
        },
    },

    data() {
        return {
            openModal: this.showModal,
            email: this.userEmail,
            phone: null,
            size: null,
            message: null,
            isSending: false,
            errorMessage: null,
            successMessage: null,
            classes: {
                overlay: 'overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed z-2000 bg-black bg-opacity-50',
                wrapper: 'relative mx-auto z-50 max-w-4xl px-3 py-12',
                modal: 'bg-white shadow rounded',
                body: 'p-3',
                header: 'border-b border-gray-100 p-3 rounded-t',
                footer: 'bg-gray-100 p-3 rounded-b',
                close: 'bg-gray-100 text-gray-600 rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out hover:bg-gray-200 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
                closeIcon: 'fill-current h-4 w-4',
                overlayEnterClass: 'opacity-0',
                overlayEnterActiveClass: 'transition ease-out duration-100',
                overlayEnterToClass: 'opacity-100',
                overlayLeaveClass: 'opacity-100',
                overlayLeaveActiveClass: 'transition ease-in duration-75',
                overlayLeaveToClass: 'opacity-0',
                enterClass: '',
                enterActiveClass: '',
                enterToClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: '',
            },
        }
    },

    computed: {
        portalAvailable() {
            return 'PortalTarget' in this.$options.components
        },
    },

    watch: {
        showModal() {
            this.openModal = this.showModal
        },
    },

    methods: {
        async send() {
            if (! this.email || ! this.phone || ! this.size) {
                this.errorMessage = 'A *-al jelölt mezők megadása kötelező!'
                return
            }

            this.isSending = true
            this.errorMessage = null

            await axios.post('/api/out-of-stock/notification', {
                'product': this.product.id,
                'email': this.email,
                'phone': this.phone,
                'size': this.size,
                'message': this.message,
            }).then((response) => {
                this.successMessage = 'Üzenetét sikeresen rögzítettük!'
            }).catch((error) => {
                if (error.response.status === 422) {
                    this.errorMessage = 'A *-al jelölt mezők megadása kötelező!'
                } else {
                    this.errorMessage = 'Hiba történt a feldolgozás során!'
                }

                this.isSending = false
            })
        }
    }
}
</script>
